import { marked } from 'marked'
import DOMPurify from 'isomorphic-dompurify'

export const cleanHtmlMdString = (str: string): string => (
  str
    // remove the most common zerowidth characters from the start of the file
    // eslint-disable-next-line no-misleading-character-class
    .replace(/^[\u200B\u200C\u200D\u200E\u200F\uFEFF]/,'')
    .replace(/\\(.?)/g, (_, n1) => {
      switch (n1) {
      case '\\':
        return '\\'
      case '0':
        return '\u0000'
      case '':
        return ''
      default:
        return n1
      }
    })
)

export const handleIncomingString = (incomingString: string): string => {
  const parsed = marked.parse(
    cleanHtmlMdString(incomingString),
    { async: false, breaks: true, gfm: true },
  )

  return DOMPurify.sanitize(parsed, { ADD_TAGS: ['iframe'] })
}
